 <template>
  <div class="my_container">
    <div class="my_breadcrumb_box">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/research/:id', query: { id: researchId } }">研究院生态</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/bookList', query: { id: researchId }  }">书籍列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{detail.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="glag_left">
      <div class="text_detail_box book_detail_box">
        <div class="text_detail_title">{{detail.title}}</div>
        <div class="text_detail_content">
          <div class="book_detail_top">
            <div class="book_detail_img lf">
              <img :src="detail.book_img" alt="封面">
            </div>
            <div class="book_detail_info lf">
              <p><span>作者：</span>{{detail.author}}</p>
              <p><span>出版方：</span>{{detail.press}}</p>
            </div>
          </div>
          <div class="book_detail_bottom">
            <p class="book_detail_content_title">内容简介</p>
            <div v-if="detail.content === ''">暂无书籍简介</div>
            <div v-else class="book_detail_content" v-html="detail.content"></div>
          </div>
        </div>
        <div class="text_detail_files" v-if="detail.more.length > 0">
          <span>附件：</span>
          <div v-for="item in detail.more" :key="item.id" class="text_detail_files_item">
            <a :href="item.path">点击下载：{{item.name}}</a>
          </div>
        </div>
        <div class="text_detail_address" v-if="detail.type === '2'">
          <span>文章转载自：{{detail.address}}</span>
        </div>
        <div class="expert_list_other rt">
          <share-view :detail="detail"></share-view>
        </div>
      </div>
      <comment-view
      :comments = "comment"
      :list-id = "commentList.list_id"
      :user = "user"
      :mescount = "detail.mes_count"
      :participatecount = "detail.participate_count"
      ></comment-view>
    </div>
    <div class="glag_right">
      <recommend-view v-if="recommendList !== null" :list="recommendList"></recommend-view>
    </div>
  </div>
</template>

<script>
import comment from '../Public/comment.vue'
import recommend from '../Public/detailRecommendList.vue'
import share from '../Public/share.vue'
export default {
  components: {
    commentView: comment,
    recommendView: recommend,
    shareView: share
  },
  data () {
    return {
      researchId: '', // 研究院id
      childOnOff: false, // 子组建渲染开关
      commentList: {
        list_id: '',
        sort: 1 // 评论排序：1热度查询，时间查询
      },
      detail: {
        more: []
      }, // 文章详情
      user: {}, // 作者信息
      comment: {
        comments: []
      }, // 评论列表
      recommendList: null // 相关内容推荐
    }
  },
  created () {
    const vueThat = this
    vueThat.commentList.list_id = vueThat.$route.query.id
    vueThat.getDetail()
  },
  methods: {
    // 个人中心页面跳转
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    },
    // 获取详情信息
    getDetail () {
      const vueThat = this
      vueThat.myApi.getBookDetails({ list_id: vueThat.commentList.list_id, research_id: '' }).then((res) => {
        if (res.data.code === 200) {
          vueThat.childOnOff = true
          vueThat.researchId = res.data.data.data.research_id
          vueThat.detail = res.data.data.data
          vueThat.comment.comments = res.data.data.mes_data
          vueThat.recommendList = res.data.data.right
        }
      })
    },
    // 关注
    addFollow (id) {
      const vueThat = this
      vueThat.myApi.addFollow({ user_id: id }).then((res) => {
        if (res.data.code === 200) {
          vueThat.$alert('关注成功', '温馨提示', {
            type: 'success',
            iconClass: 'iconfont icon-icon_richeng_btn_pass',
            confirmButtonText: '确定',
            showClose: false,
            callback: action => {
              vueThat.user.fans_count += 1
              vueThat.user.is_follow = 1
            }
          })
        }
      })
    },
    // 取消关注
    cancelFollow (id) {
      const vueThat = this
      vueThat.$confirm('是否取消关注?', '温馨提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(id)
        vueThat.myApi.cancelFollow({ user_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.user.fans_count -= 1
            vueThat.user.is_follow = 0
          }
        })
      }).catch(() => {})
    }
  }
}
</script>

<style>
  .article_user_head{
    position: relative;
  }
  .article_user_head .my_follow_btn{
    position: absolute;
    bottom: -3px;
    right: -57px;
  }
  .article_user_head .glay_btn{
    position: absolute;
    bottom: -3px;
    right: -70px;
  }
</style>
